module.exports = __webpack_public_path__ + "img/Creditos.6db34dff.svg";